/* Revita Derma · páginas de apoio: conferência do formulário de contato antes de enviar
   e busca do pedido (app de rastreio configurado ou conta da cliente). */
(function(){
  const EMAIL=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function confere(f,regras){
    let bom=true;
    regras.forEach(([sel,teste,msg])=>{
      const el=f.querySelector(sel);if(!el)return;
      const er=el.parentNode.querySelector('.erro'),ok=teste(el.value);
      if(er)er.textContent=ok?'':msg;
      el.setAttribute('aria-invalid',String(!ok));
      if(!ok&&bom){el.focus();bom=false;}
    });
    return bom;
  }
  document.querySelectorAll('[data-rv-contato] form').forEach(f=>f.addEventListener('submit',e=>{
    if(!confere(f,[['[name="contact[name]"]',v=>v.trim().length>1,'Conte seu nome.'],['[name="contact[email]"]',v=>EMAIL.test(v),'Confira o e-mail.'],['[name="contact[body]"]',v=>v.trim().length>4,'Escreva sua mensagem.']]))e.preventDefault();
  }));
  document.querySelectorAll('[data-rv-rastrear]').forEach(s=>{
    const f=s.querySelector('form');if(!f)return;
    f.addEventListener('submit',e=>{
      e.preventDefault();
      if(!confere(f,[['[name="pedido"]',v=>v.replace(/\D/g,'').length>=3,'Confira o número do pedido.'],['[name="email"]',v=>EMAIL.test(v),'Confira o e-mail.']]))return;
      const ped=f.pedido.value.replace(/\D/g,''),em=f.email.value.trim(),url=s.dataset.url;
      window.location.href=url?url.replace('{pedido}',encodeURIComponent(ped)).replace('{email}',encodeURIComponent(em)):s.dataset.conta;
    });
  });
})();
